export class Entry {
    public id: number;
    public entriesable_id: number;
    public label: {default: string};
    public url: {default: string};
    public blank: boolean;
    public hierarchy: boolean;
    public parent_id: number;
    public type: number;
    public page_id: number;
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;


    constructor() {
        this.id = 0;
        this.entriesable_id = 0;
        this.label = {default: ''};
        this.url = {default: ''};
        this.blank = false;
        this.hierarchy = false;
        this.parent_id = 0;
        this.type = 0;
        this.page_id = 0;
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
        
    }
}
